// ---- 工作台路由 ----/

// 运管端基础数据看板
const operationIndex = () => import('@pv/mainCenter/operation/dataIndex');

// 服务端基础数据看板
const serviceIndex = () => import('@pv/mainCenter/service/Index');

// 教育局基础数据看板
const educationShowData = () => import('@pv/mainCenter/education/ShowData');

// 教育局基础数据看板
const educationShowEduData = () => import('@pv/mainCenter/education/ShowEduData');

// 教育局首页
const EducationIndex = () =>
  import(/* webpackChunkName: "education" */ '@pv/mainCenter/education/NewIndex');

// 教育局端报名数据统计
const eduRegistrationDataStatistics = () => import('@pv/mainCenter/education/RegistrationDataStatistics');

// 教育局端财务数据统计
const eduCourseIncomeDataStatistics = () => import('@pv/mainCenter/education/CourseIncomeDataStatistics');

export default [
  // 运管端基础数据看板
  {
    path: '/mainCenter/operationIndex',
    name: 'operationIndex',
    meta: {
      title: '数据概览',
      activePath: '/mainCenter/operationIndex',
      breadcrumb: '工作台-数据概览'
    },
    component: operationIndex
  },
  // 学校端基础数据看板
  {
    path: '/mainCenter/schoolIndex',
    name: 'schoolIndex',
    meta: {
      title: '数据概览',
      activePath: '/mainCenter/schoolIndex',
      breadcrumb: '工作台-数据概览'
    },
    component: operationIndex
  },
  // 服务端基础数据看板
  {
    path: '/mainCenter/serviceIndex',
    name: 'serviceIndex',
    meta: {
      title: '数据概览',
      activePath: '/mainCenter/serviceIndex',
      breadcrumb: '工作台-数据概览'
    },
    component: serviceIndex
  },
  // 教育局端基础数据看板
  {
    path: '/mainCenter/educationShowData',
    name: 'educationShowData',
    meta: {
      title: '数据概览',
      activePath: '/mainCenter/educationShowData',
      breadcrumb: '工作台-数据概览'
    },
    component: educationShowData
  },
  {
    path: '/mainCenter/education/educationShowEduData',
    name: 'mainCenter_education_educationShowEduData',
    meta: {
      title: '数据概览',
      activePath: '/mainCenter/education/educationShowEduData',
      breadcrumb: '工作台-数据概览'
    },
    component: educationShowEduData
  },
  {
    path: '/mainCenter/education/educationIndex',
    name: 'mainCenter_education_educationIndex',
    meta: {
      title: '数据概览',
      activePath: '/mainCenter/education/educationIndex',
      breadcrumb: '工作台-数据概览-数据看板'
    },
    component: EducationIndex
  },
  // 教育局端报名数据统计
  {
    path: '/mainCenter/education/eduRegistrationDataStatistics',
    name: 'mainCenter_education_eduRegistrationDataStatistics',
    meta: {
      title: '报名数据统计',
      activePath: '/mainCenter/education/eduRegistrationDataStatistics',
      breadcrumb: '工作台-数据概览-报名数据统计'
    },
    component: eduRegistrationDataStatistics
  }, // 教育局端报名数据统计
  {
    path: '/mainCenter/education/eduCourseIncomeDataStatistics',
    name: 'mainCenter_education_eduCourseIncomeDataStatistics',
    meta: {
      title: '财务数据统计',
      activePath: '/mainCenter/education/eduCourseIncomeDataStatistics',
      breadcrumb: '工作台-数据概览-财务数据统计'
    },
    component: eduCourseIncomeDataStatistics
  }
];
